/** Vedi nota in `environment.ts`. */
export interface StoreLinks {
  android?: string;
  ios?: string;
}

export const environment = {
  production: false,
  respectBrowserUrl: true,
  servicesUrl: 'https://dev-api.civeshub.it/civeshub',
  servicesPraticheUrl: 'https://dev-api.civeshub.it/civeshub',
  recaptcha: {
    siteKey: '6Lf7yl8tAAAAAOylq-lHhzGBzRKJNFTksPJ1fXiH',
    // Verifica anti-bot attiva: vedi nota in environment.ts. Va tenuto allineato al flag
    // backend `civeshub.recaptcha.enable`, qui `true`.
    enabled: true,
  },
  // Metodi di login: vedi nota in environment.ts. Solo su DEV la CIE è attiva accanto alle
  // credenziali; SPID resta nascosto. In prod CIE resta spenta (environment.prod.ts).
  auth: {
    methods: { credentials: true, spid: false, cie: true },
    // CIE di pre-produzione (Keycloak dev): vedi nota in environment.ts.
    cieAlias: 'cieid-testing',
  },
  spid: {
    authority: 'https://dev-keycloak-upgrade.southengineering.it/auth/realms/civeshub',
    clientId: 'civeshub-client',
    redirectUri: 'http://localhost:5200/auth/callback',
    postLogoutRedirectUri: 'http://localhost:5200/login',
    scope: 'openid profile email offline_access',
  },
  app: {
    store: {
      // TODO: valorizzare con l'URL Google Play quando l'app Android sarà pubblicata
      android: '',
      // TODO: valorizzare con l'URL App Store quando l'app iOS sarà pubblicata
      ios: '',
    } as StoreLinks,
  },
};

